<template>
  <div class="text-xs py-2" style="box-shadow: inset 0 0 20px 5px #121212;" v-if="config.ActionPopup">

    <div class="flex">
      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'reseaux',
        'hover:bg-g2 hover:text-g3': state != 'reseaux'
      }" @click="ChangeState('reseaux')">
        {{ $e('Réseaux') }}
      </span>

      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'localisation',
        'hover:bg-g2 hover:text-g3': state != 'localisation'
      }" @click="ChangeState('localisation')">
        {{ $e('Localisation') }}
      </span>

      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'drone',
        'hover:bg-g2 hover:text-g3': state != 'drone'
      }" @click="ChangeState('drone')" v-if="!DroneStatus">
        {{ $e('Drone') }}
      </span>

      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'parachute',
        'hover:bg-g2 hover:text-g3': state != 'parachute'
      }" @click="ChangeState('parachute')" v-if="config?.parachute?.id">
        {{ $e('Parachute') }}
      </span>
    </div>

    <div class="flex justify-between flex-col">
      <!-- RESEAUX -->
      <div v-if="state == 'reseaux'" class="flex border border-g0 justify-around py-2 color-white">
        <RcPlus4G :config="config" />
        <RcPlus4GNetQuality :config="config" />
        <RcPlus4GNetQualityToDrone :config="config" />

        <RcPlusSdrNetQuality :config="config" />
      </div>

      <div v-if="state == 'localisation'" class="flex border border-g0 justify-around py-2 color-white">
        <RcPlusLocalisation :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, toRaw } from "vue";

import RcPlus4G from "@/partials/Device/Template/Rc+/RcPlus4G.vue";
import RcPlus4GNetQuality from "@/partials/Device/Template/Rc+/RcPlus4GNetQuality.vue";
import RcPlus4GNetQualityToDrone from "@/partials/Device/Template/Rc+/RcPlus4GNetQualityToDrone.vue";
import RcPlusSdrNetQuality from "@/partials/Device/Template/Rc+/RcPlusSdrNetQuality.vue";
import RcPlusLocalisation from "@/partials/Device/Template/Rc+/RcPlusLocalisation.vue";

export default {
  name: "RcPlusAction",
  components: {
    RcPlus4G,
    RcPlus4GNetQuality,
    RcPlus4GNetQualityToDrone,
    RcPlusSdrNetQuality,
    RcPlusLocalisation,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      state: ref("reseaux"),
    };
  },

  mounted() {

  },

  methods: {
    ChangeState(state) {
      if (this.state == state) {
        this.config.ActionPopup = false
        return;
      }
      this.state = state;
    },
  },


  computed: {
    DroneStatus() {
      if (this.config?.drone?.status?.LastPing != undefined) {
        return this.config.drone.status.LastPing > ENV.DEVICE_OFFLINE;
      }
      return true;
    },
  },
};
</script>
